import { render, staticRenderFns } from "./RegisteredDataComponent.vue?vue&type=template&id=16ca0bc3&scoped=true"
import script from "./RegisteredDataComponent.vue?vue&type=script&lang=js"
export * from "./RegisteredDataComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisteredDataComponent.vue?vue&type=style&index=0&id=16ca0bc3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca0bc3",
  null
  
)

export default component.exports